// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"28922ae0","332":"9720767a","453":"5864bd66","633":"3f02140e"}[chunkId] + ".chunk.js";
};